/**
 * Slab detection — a graded Condition/Grade means the card IS a slab.
 * Central rule so no entry path can leave a "PSA 10" marked Raw
 * (found live 2026-07-26: manually-typed grade kept Inventory Class Raw,
 * which also made the eBay listing modal treat the card as Ungraded).
 */
const GRADER_TOKENS = new Set([
  "PSA", "BGS", "CGC", "SGC", "TAG", "ACE", "GMA", "HGA", "KSA", "ISA", "ARS",
]);

/** True when a Condition/Grade string looks like a grading-company grade
 *  ("PSA 10", "BGS 9.5", "CGC 10 Pristine", "SGC Authentic"). */
export function looksGraded(condGrade: string): boolean {
  const m = String(condGrade || "").trim().match(/^([A-Za-z]{2,4})[\s-]+([\d.]+|Authentic|Pristine|Perfect)/i);
  return !!m && GRADER_TOKENS.has(m[1]!.toUpperCase());
}

/** Inventory Class for a new card given its condition text. */
export function classForCondition(condGrade: string): "Slab" | "Raw" {
  return looksGraded(condGrade) ? "Slab" : "Raw";
}
